/* eslint-disable import/prefer-default-export */
import _find from 'lodash/find';

export const isShopConfigurationRequired = shopConfiguration => {
  if (!shopConfiguration.productCategoryID) return true;
  if (shopConfiguration.pickUpAddresses) {
    const unverifiedPoi = _find(
      shopConfiguration.pickUpAddresses,
      x => !x.poiID || !x.grabPoi,
    );
    if (unverifiedPoi) return true;
  }
  return false;
};
